var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewQuestionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.92 16.543a6 6 0 1 1 1.28-1.548l-1.225-1.226a1 1 0 1 0-1.414 1.415l1.359 1.359zm1.417 1.417a8 8 0 1 1 1.315-1.514l1.566 1.566a1 1 0 0 1-1.415 1.414l-1.466-1.466z",
    fill: "#BE69C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewQuestionActive);
export default __webpack_public_path__ + "static/media/new_question_active.f3db558d16fd82ae82d9bf0a2c805f47.svg";
export { ForwardRef as ReactComponent };